import {BaseModel} from './base.model';
import {ResponseError} from './response-error.model';

export class ResponseBase<M extends BaseModel> {
    public success: boolean = false;
    public count: number = 0;
    public results: M[] = [];
    public errors: ResponseError[] = [];
}
